import { useMemo } from 'react';
import styled from 'styled-components';

import { EnforcePageWidth, StyledBackgroundGradientFlipped } from '@/layout/PageLayout';
import { AccommodationProduct } from '@/pages/Accommodation/AccommodationProduct';
import { StyledItineraryBlock, StyledSubtitle } from '@/pages/Accommodation/styles';

import type { ItineraryBlock } from '@/types/itinerary';

interface AccommodationBlockProps {
  block: ItineraryBlock;
  openModal: (id: number) => void;
  closeModal: (id: number) => void;
  modalStates: { [key: string]: boolean };
  index: number;
}
const StyledBackgroundUnset = styled.div`
  background: unset;
`;

export function AccommodationBlock({ block, modalStates, openModal, closeModal, index }: AccommodationBlockProps) {
  const accommodationProducts = useMemo(
    () => block.ItineraryProducts?.filter((product) => product.type?.toLocaleLowerCase() === 'accommodation'),
    [block.ItineraryProducts],
  );

  const BackgroundWrapper = useMemo(
    () => (index === 0 ? StyledBackgroundUnset : StyledBackgroundGradientFlipped),
    [index],
  );

  return (
    <BackgroundWrapper>
      <EnforcePageWidth>
        <StyledItineraryBlock>
          <StyledSubtitle>
            {`Day ${block.startDay} t/m ${Number(block.startDay) + Number(block.duration)}`}
          </StyledSubtitle>
          <h1>{block.location}</h1>
          {accommodationProducts.map((product) => (
            <AccommodationProduct
              key={product.id}
              product={product}
              openModal={openModal}
              closeModal={closeModal}
              modalStates={modalStates}
            />
          ))}
        </StyledItineraryBlock>
      </EnforcePageWidth>
    </BackgroundWrapper>
  );
}
